import { createSlice } from "@reduxjs/toolkit";

const defaultConflictData = {
  conflicts: ["Conflicted", "Brand", "Flavour", "Size", "Sub SKU", "Others"],
  curConflict: null,
  conflictedBrands: [],
  selectedConflictBrand: null,
  selectedThumbnailsToMarkCorrect: [],
};

export const conflictData = createSlice({
  name: "conflictData",
  initialState: defaultConflictData,
  reducers: {
    setCurConflict(state, action) {
      state.curConflict = action.payload;
    },
    setConflictedBrands(state, action) {
      state.conflictedBrands = action.payload.brands;
    },
    setSelectedConflictedBrand(state, action) {
      state.selectedConflictBrand = action.payload;
    },
    appendToSelectedThumbnails(state, action) {
      const selectedThumbnail = action.payload;

      // Check if the thumbnail is already in the array
      const thumbnailIndex = state.selectedThumbnailsToMarkCorrect.findIndex(
        (thumbnail) => thumbnail.thumbnailName === selectedThumbnail.thumbnailName
      );

      if (thumbnailIndex === -1) {
        // If not present, append it to the array
        state.selectedThumbnailsToMarkCorrect.push(selectedThumbnail);
      } else {
        // If present, remove it from the array
        state.selectedThumbnailsToMarkCorrect.splice(thumbnailIndex, 1);
      }
    },
    resetSelectedThumbnailsToMarkCorrect(state,action){
      state.selectedThumbnailsToMarkCorrect=[]
    },
    resetConflictedData(state, action) {
      state.curConflict = null;
      state.conflictedBrands = [];
      state.selectedConflictBrand = null;
      state.selectedThumbnailsToMarkCorrect=[]
    },
  },
});
